// Form
import * as yup from "yup"

export const validationSchema = yup.object().shape({
  category_customer_code: yup.string().label("Category customer code").required(),
  category_customer_name: yup.string().label("Category customer name").required()
})